module.exports = __webpack_public_path__ + "static/media/microsoft.825b94bd.svg";